/* Source: src/mt-includes/js/src/core/entertainment/init.js*/
angular.module('website.core.entertainment', [
    'website.core.animation'
]);